/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from "relay-runtime";

import { FragmentRefs } from "relay-runtime";
export type OnboardingOrgInvite_viewer = {
    readonly user: {
        readonly " $fragmentRefs": FragmentRefs<"CopyPersonalInviteLinkBtn_user">;
    } | null;
    readonly personQueryResultErrorable: {
        readonly __typename: "GraphEntityError";
        readonly statusCode: number | null;
        readonly message: string | null;
    } | {
        readonly __typename: "PersonQueryResult";
        readonly query: string;
        readonly persons: ReadonlyArray<{
            readonly id: string;
            readonly primaryEmail: string;
            readonly emails: ReadonlyArray<string>;
            readonly profile: {
                readonly givenName: string | null;
                readonly familyName: string | null;
                readonly externalImageUrl: string | null;
            } | null;
            readonly isYou: boolean;
            readonly isUser: boolean;
        } | null>;
    } | {
        /*This will never be '%other', but we need some
        value in case none of the concrete values match.*/
        readonly __typename: "%other";
    };
    readonly " $refType": "OnboardingOrgInvite_viewer";
};
export type OnboardingOrgInvite_viewer$data = OnboardingOrgInvite_viewer;
export type OnboardingOrgInvite_viewer$key = {
    readonly " $data"?: OnboardingOrgInvite_viewer$data | undefined;
    readonly " $fragmentRefs": FragmentRefs<"OnboardingOrgInvite_viewer">;
};



const node: ReaderFragment = {
    "argumentDefinitions": [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "excludeCalendars"
        },
        {
            "defaultValue": "",
            "kind": "LocalArgument",
            "name": "orgRelayId"
        },
        {
            "defaultValue": "",
            "kind": "LocalArgument",
            "name": "queryInput"
        }
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "OnboardingOrgInvite_viewer",
    "selections": [
        {
            "alias": null,
            "args": null,
            "concreteType": "User",
            "kind": "LinkedField",
            "name": "user",
            "plural": false,
            "selections": [
                {
                    "args": null,
                    "kind": "FragmentSpread",
                    "name": "CopyPersonalInviteLinkBtn_user"
                }
            ],
            "storageKey": null
        },
        {
            "alias": null,
            "args": [
                {
                    "kind": "Variable",
                    "name": "excludeCalendars",
                    "variableName": "excludeCalendars"
                },
                {
                    "kind": "Variable",
                    "name": "orgRelayId",
                    "variableName": "orgRelayId"
                },
                {
                    "kind": "Variable",
                    "name": "query",
                    "variableName": "queryInput"
                }
            ],
            "concreteType": null,
            "kind": "LinkedField",
            "name": "personQueryResultErrorable",
            "plural": false,
            "selections": [
                {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "__typename",
                    "storageKey": null
                },
                {
                    "kind": "InlineFragment",
                    "selections": [
                        {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "statusCode",
                            "storageKey": null
                        },
                        {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "message",
                            "storageKey": null
                        }
                    ],
                    "type": "GraphEntityError",
                    "abstractKey": null
                },
                {
                    "kind": "InlineFragment",
                    "selections": [
                        {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "query",
                            "storageKey": null
                        },
                        {
                            "alias": null,
                            "args": null,
                            "concreteType": "Person",
                            "kind": "LinkedField",
                            "name": "persons",
                            "plural": true,
                            "selections": [
                                {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "id",
                                    "storageKey": null
                                },
                                {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "primaryEmail",
                                    "storageKey": null
                                },
                                {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "emails",
                                    "storageKey": null
                                },
                                {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "UserProfile",
                                    "kind": "LinkedField",
                                    "name": "profile",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "alias": null,
                                            "args": null,
                                            "kind": "ScalarField",
                                            "name": "givenName",
                                            "storageKey": null
                                        },
                                        {
                                            "alias": null,
                                            "args": null,
                                            "kind": "ScalarField",
                                            "name": "familyName",
                                            "storageKey": null
                                        },
                                        {
                                            "alias": null,
                                            "args": null,
                                            "kind": "ScalarField",
                                            "name": "externalImageUrl",
                                            "storageKey": null
                                        }
                                    ],
                                    "storageKey": null
                                },
                                {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "isYou",
                                    "storageKey": null
                                },
                                {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "isUser",
                                    "storageKey": null
                                }
                            ],
                            "storageKey": null
                        }
                    ],
                    "type": "PersonQueryResult",
                    "abstractKey": null
                }
            ],
            "storageKey": null
        }
    ],
    "type": "Viewer",
    "abstractKey": null
} as any;
(node as any).hash = '4d60ef0965248599481f327c257d2693';
export default node;
